import {
  GetAllProductsRequestBuilder,
  GetProductsCountRequestBuilder,
  UpdateProductRequestBuilder,
  CreateProductRequestBuilder,
  GetProductsInventoryRequestBuilder,
  GetProductsVariantRequestBuilder,
  GetVariantsRequestBuilder,
  GetCategoriesRequestBuilder,
  GetProductsVariantInventoryItemsRequestBuilder,
  GetPartnerCategoriesBuilder,
  SubmitProductInfo,
  GetVitrinCategories,
  CreateVitrinProduct,
  GetVitrinProduct,
  UploadImage,
  GetImage,
  RemoveImage,
  RemoveVitrinProduct,
  UpdateVitrinProduct,
  GetVitrinProductById,
  GetAllVitrinProductsRequestBuilder,
  GetVitrinProductCount,
  UnSelectVitrinProduct,
  SelectVitrinProduct,
  GetVitrinSelectedProducts,
  GetVitrinSelectedProductsCount,
  DeleteVariantsBuilder,
  CreatePartnerCategoryBuilder,
  UploadImageRequestBuilder,
} from '../products/products';
import Client, {VitrinClient} from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class ProductRepository {
  submitProducts = async (actions: any) => {
    const makeRequest = new SubmitProductInfo().data(actions.payload).build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  createPartnerCategory = async (actions: any) => {
    const makeRequest = new CreatePartnerCategoryBuilder().data(actions.payload).build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  submitSingleProduct = async (actions: any) => {
    const makeRequest = new SubmitProductInfo()
      .id(actions.id)
      .data(actions.payload)
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  uploadProductImage = async (actions: any) => {
    const makeRequest = new UploadImageRequestBuilder()
      .id(actions.id)
      .data(actions.payload)
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getProducts = async (actions: any) => {
    const makeRequest = new GetAllProductsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetProductsCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getProduct = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new GetAllProductsRequestBuilder().id(id).build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getVariant = async (actions: any) => {
    const {id, params} = actions.payload;
    let makeRequest;
    if (id) {
      makeRequest = new GetVariantsRequestBuilder().id(id).build();
    } else {
      makeRequest = makeRequest = new GetVariantsRequestBuilder()
        .params(flattenObject({...params}))
        .build();
    }

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response, id};
  };
  deleteVariants = async (actions: any) => {
    const {id, pagination, callback} = actions.payload;
    const makeCancelRequest = new DeleteVariantsBuilder().id(id).build();
    const client = new Client(token);
    await client.execute(makeCancelRequest);
    return {pagination, callback};
  };
  getCategories = async (actions: any) => {
    const makeRequest = new GetCategoriesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getPartnerCategories = async (actions: any) => {
    const makeRequest = new GetPartnerCategoriesBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getAllProducts = async (actions: any) => {
    const makeRequest = new GetAllProductsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateProduct = async (actions: any) => {
    const {body, pagination, id, callback} = actions.payload;
    const makeUpdateRequest = new UpdateProductRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return {pagination, callback, id};
  };
  createProduct = async (actions: any) => {
    const {body, pagination, id, callback} = actions.payload;
    const makeRequest = new CreateProductRequestBuilder().data(body).build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {pagination, callback, id, response};
  };
  getProductsInventory = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new GetProductsInventoryRequestBuilder()
      .id(id)
      .params(flattenObject({sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getProductVariants = async (actions: any) => {
    const {id, ...actionPayload} = actions.payload;
    const makeRequest = new GetProductsVariantRequestBuilder()
      .id(id)
      .params(flattenObject({...actionPayload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getProductVariantInventoryItems = async (actions: any) => {
    const makeRequest = new GetProductsVariantInventoryItemsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getVitrinCategories = async (actions: any) => {
    const makeRequest = new GetVitrinCategories().build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  CreateVitrinProduct = async (actions: any) => {
    const {body} = actions.payload;
    const makeRequest = new CreateVitrinProduct().data(body).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getVitrinProduct = async (actions: any) => {
    const makeRequest = new GetVitrinProduct()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getVitrinProductCount = async (actions: any) => {
    const makeRequest = new GetVitrinProductCount()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getVitrinProductWithId = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new GetVitrinProductById().id(id).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  removeVitrinProduct = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new RemoveVitrinProduct().id(id).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  unSelectVitrinProduct = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new UnSelectVitrinProduct().id(id).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  selectVitrinProduct = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new SelectVitrinProduct().id(id).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getVitrinSelectedProduct = async (actions: any) => {
    const makeRequest = new GetVitrinSelectedProducts()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  updateVitrinProduct = async (actions: any) => {
    const {body, id} = actions.payload;
    const makeRequest = new UpdateVitrinProduct().data(body).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  uploadImageToVitrin = async (actions: any) => {
    const {body, id} = actions.payload;
    const makeRequest = new UploadImage().id(id).data(body).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getImagefromVitrin = async (actions: any) => {
    const {id, fileName} = actions.payload;
    const makeRequest = new GetImage().id(id, fileName).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  removeImagefromVitrin = async (actions: any) => {
    const {id, fileName} = actions.payload;
    const makeRequest = new RemoveImage().id(id, fileName).build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getVitrinProducts = async (actions: any) => {
    const makeRequest = new GetAllProductsRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };

  getVitrinSelectedProductsCount = async (actions: any) => {
    const makeRequest = new GetVitrinSelectedProductsCount()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new VitrinClient(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}
export default new ProductRepository();
